module.exports = __webpack_public_path__ + "img/0Q3A7086_FoamcoreMatted.002df25a.jpg";